shadow$provide[476] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, IN:{enumerable:true, get:function() {
  return IN;
}}, OUT:{enumerable:true, get:function() {
  return OUT;
}}});
var require$_DOT__SLASH_graph = require("./graph");
var require$_DOT__SLASH_node = require("./node");
var require$_DOT__SLASH_outlet = require("./outlet");
const {IN, OUT} = require$_DOT__SLASH_graph.Graph;
require.exportCopy(module, require$_DOT__SLASH_graph);
require.exportCopy(module, require$_DOT__SLASH_node);
require.exportCopy(module, require$_DOT__SLASH_outlet);

};